class KlaviyoBis extends HTMLElement {
  connectedCallback() {
    this.companyId = this.dataset.companyId;
    this.sectionId = this.dataset.sectionId;
    this.form = this.querySelector("[data-bis-form]");
    this.btnText = this.querySelector("[data-bis-text]");
    this.btnSpinner = this.querySelector("[data-bis-spinner]");
    this.message = this.querySelector("[data-bis-message]");
    if (!this.form || !this.companyId) return;
    this.form.addEventListener("submit", (e) => this.handleSubmit(e));
    this.observeVariantChanges();
  }
  observeVariantChanges() {
    document.addEventListener("variant:change", (e) => {
      if (e.detail.sectionId !== this.sectionId) return;
      this.dataset.variantId = e.detail.variantId;
      this.classList.toggle("hidden", e.detail.available);
      this.hideMessage();
    });
  }
  async handleSubmit(e) {
    e.preventDefault();
    const email = this.form.querySelector('input[name="email"]').value;
    if (!email) return;
    this.setLoading(true);
    try {
      const res = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${this.companyId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-02-15"
          },
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${this.dataset.variantId}`
                  }
                }
              }
            }
          })
        }
      );
      if (res.ok || res.status === 202) {
        this.showMessage(this.dataset.successMessage, "success");
      } else {
        throw new Error("Subscription failed");
      }
    } catch {
      this.showMessage(this.dataset.errorMessage, "error");
    }
    this.setLoading(false);
  }
  setLoading(loading) {
    const btn = this.form.querySelector('button[type="submit"]');
    btn.disabled = loading;
    this.btnText.classList.toggle("hidden", loading);
    this.btnSpinner.classList.toggle("hidden", !loading);
  }
  showMessage(text, type) {
    this.message.textContent = text;
    this.message.classList.remove("hidden", "text-green-600", "text-red-600");
    this.message.classList.add(type === "success" ? "text-green-600" : "text-red-600");
  }
  hideMessage() {
    this.message.classList.add("hidden");
  }
}
window.customElements.define("klaviyo-bis", KlaviyoBis);
